import React from 'react';

export function NeedsLoadingProgress({ label = 'Cargando necesidades…', current, total }) {
  const determinate = Number.isFinite(total) && total > 0;
  const percent = determinate ? Math.min(100, Math.round(current / total * 100)) : undefined;
  return <div role="status" className="space-y-2 rounded border border-blue-200 bg-blue-50 p-3 text-sm text-blue-900">
    <div className="flex justify-between gap-3"><span>{label}</span>{determinate && <span className="tabular-nums">{current} / {total} · {percent}%</span>}</div>
    <progress aria-label={label} max={100} value={percent} className="block h-2 w-full accent-blue-600" />
  </div>;
}

// Let the browser paint between batches, keeping large reports responsive.
export function useProgressiveNeeds(items, batchSize = 15) {
  const [state, setState] = React.useState({ items: null, count: 0 });
  const count = state.items === items ? state.count : 0;
  React.useEffect(() => {
    if (count >= items.length) return;
    const timer = window.setTimeout(() => setState({ items, count: Math.min(items.length, count + batchSize) }), 16);
    return () => window.clearTimeout(timer);
  }, [items, count, batchSize]);
  return { visible: items.slice(0, count), current: count, total: items.length, loading: count < items.length };
}
